import { render, staticRenderFns } from "./redemption-drawer.vue?vue&type=template&id=4df8b30d&scoped=true&"
import script from "./redemption-drawer.vue?vue&type=script&lang=js&"
export * from "./redemption-drawer.vue?vue&type=script&lang=js&"
import style0 from "./redemption-drawer.vue?vue&type=style&index=0&id=4df8b30d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df8b30d",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DrawerHeader: require('/app/components/drawer/components/drawerHeader.vue').default,SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
